import { useMemo } from 'react';
import { DataExporter } from '../../libs/DataExporter';
import { BillingTableItem } from './types';

export const useInvoiceCsvExporter = ({ currency }: { currency: string }) =>
  useMemo(
    () =>
      new DataExporter<BillingTableItem>([
        { id: 'invoiceNumber', label: 'Invoice: Invoice Number', valueAccessor: 'InvoiceNumber' },
        { id: 'poNumber', label: 'Invoice: PO Number', valueAccessor: 'PONumber__c' },
        { id: 'invoiceDate', label: 'Invoice: Invoice Date', valueAccessor: 'InvoiceDate' },
        { id: 'amount', label: 'Invoice: Amount', valueAccessor: 'Amount' },
        { id: 'balance', label: 'Invoice: Balance', valueAccessor: 'Balance' },
        { id: 'currency', label: 'Account: currency', valueAccessor: () => currency },
      ]),
    [currency],
  );
